/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getAttachmentIcon } from 'app/components/Notification/Common/AttachmentFileTypes';
import moment from 'moment';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { ExceptionWaiveAttachment } from './models/PlacementDialogModels';
import { getAttachmentName } from './ExceptionWaiveAttachments/DocumentDragDropHelper';

const useStyles = makeStyles()(theme => ({
  listItem: {
    width: '33.33%',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  listRoot: {
    maxHeight: '300px',
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    padding: `0px`,
  },
  footer: {
    fontSize: '11px',
    color: '#8E9195',
    paddingRight: '5px',
  },
  header: {
    fontSize: '14px',
    color: '#555555',
    paddingLeft: '10px',
  },
}));

export const AttachmentView = ({ attachments }: { attachments?: ExceptionWaiveAttachment[] }) => {
  const { classes } = useStyles();
  return (
    <LayoutGrid className={classes.listRoot}>
      {attachments ? (
        attachments?.map((attachment: ExceptionWaiveAttachment, idx) => (
          <LayoutGridItem
            key={idx}
            className={classes.listItem}
            onClick={() => {
              window.open(attachment?.saasAttachmentUrl || '', '_blank');
            }}
            xs={6}
          >
            <LayoutGrid direction="column" style={{ padding: '15px 5px' }}>
              <LayoutGridItem xs={12} style={{ padding: '0' }}>
                <img
                  src={getAttachmentIcon(attachment?.attachmentType && attachment?.attachmentType.toLowerCase())}
                  alt={`FileIcon`}
                  style={{ width: '12px' }}
                />
                <Typography component="span" className={classes.header}>
                  {attachment?.title || `${'Attachment Title ' + (idx + 1)}`}
                </Typography>
              </LayoutGridItem>
              <LayoutGridItem xs={12} style={{ padding: '0', paddingLeft: '22px' }}>
                <Typography component="span">{getAttachmentName(attachment?.attachmentUrl)}</Typography>
              </LayoutGridItem>
              <LayoutGridItem xs={12} style={{ padding: '0', paddingLeft: '22px' }}>
                <Typography component="span" className={classes.footer}>
                  {`Added ${
                    attachment?.dateAdded
                      ? moment(attachment?.dateAdded).format('MM/DD/yyyy')
                      : moment().format('MM/DD/yyyy')
                  } by: ${attachment.addedByName || '-'}`}
                </Typography>
              </LayoutGridItem>
            </LayoutGrid>
          </LayoutGridItem>
        ))
      ) : (
        <Typography component="span" className={classes.header}>
          {'-'}
        </Typography>
      )}
    </LayoutGrid>
  );
};
